import * as constant from '@/constant/constant.js'
const DOMAIN_NAME = constant.DEFAULT_DOMAIN_NAME
/**
 * ユーティリティ
 */

/**
 * getUrls:
 *  文字列からURLを取得する。
 *
 * @param {string} message URLを入手したい文字列
 * @return {string} URL
 */
export function getUrls (message) {
  const reg = new RegExp('https?://[^\\s|^<]+', 'g')
  const matches = Array.from(new Set(message.match(reg)))
  return matches
}

/**
 * removeUrl:
 *   文字列からURLを除去する。
 *
 * @param {string} message URLを除去したい文字列
 * @return {string} URLを除去したmessage
 */
export function removeUrl (message) {
  if (!message) { return 0 }
  const reg = new RegExp('https?://[^\\s|^<]+', 'g')
  const matches = Array.from(new Set(message.match(reg)))
  for (const match of matches) {
    message = message.replace(match, '')
  }
  if (!message) { message = 'URL' }
  return message
}

/**
 * countCharacters:
 *   文字数をカウントする。ただしURLを除く。
 *
 * @param {string} message カウントしたい文字列
 * @return {number} カウントした文字数
 */
export function countCharacters (message) {
  const messageWithoutUrl = removeUrl(message)
  if (!messageWithoutUrl) { return 0 }
  return messageWithoutUrl.length
}

/**
 * addHref:
 *   本文中にhttps?://から始まるURLが含まれていた場合ハイパーリンクにする
 *
 * @param {string} message 本文
 * @return {string} URLをハイパーリンクにした本文
 */
export function addHref (message) {
  if (!message) { return }
  // vew2-editorで既に<a href></a>で囲まれているものを除外
  const regAtag = new RegExp('<a href="(.*?)".*?>(.*?)</a>', 'gi')
  const atagMatches = Array.from(new Set(message.match(regAtag)))
  let messageExcludingAtag = message
  if (location.hostname !== DOMAIN_NAME) { console.log(atagMatches) }
  for (const match of atagMatches) {
    messageExcludingAtag = messageExcludingAtag.replace(match, '')
  }
  // http or httpsを見つけたら<a href>追加
  const regHref = new RegExp('https?://[^\\s|^<]+', 'g')
  const hrefMatches = Array.from(new Set(messageExcludingAtag.match(regHref)))
  if (location.hostname !== DOMAIN_NAME) { console.log(hrefMatches) }
  for (const match of hrefMatches) {
    if (match) {
      message = message.replace(match, '<a href="' + match + '" rel="noopener noreferrer" target="_blank">' + match + '</a>')
    }
  }
  return message
}

/**
 * removeHtml:
 *  本文中のhtml表記を削除する
 * @param {string} message 本文
 * @return {string} htmlが削除された本本
 */
export function removeHtml (message) {
  if (!message) { return }
  // vue-editorによるhtml表記の排除
  while (message.match(/<(".*?"|'.*?'|[^'"])*?>/)) {
    message = message.replace(/<(".*?"|'.*?'|[^'"])*?>/gm, '')
  }
  return message
}

/**
 * formatDate:
 *  タイムスタンプを指定の日付フォーマットに変換する
 * @param {string} date timeStamp
 * @param {string} format format形式
 * @return {string} formatされた日付
 */
export function formatDate (date, format) {
  format = format.replace(/yyyy/g, date.getFullYear())
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
  format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2))
  format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2))
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
  format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3))
  return format
}

/**
 * reduceMsg:
 *   Msgを指定文字数でカットする
 * @param {string} text nodeのメッセージ
 * @param {Number} num 指定文字数
 * @return {string} 指定文字数で減らされたtext
 */
export function reduceMsg (text, num) {
  if (!text) {
    return ''
  }
  if (text.length > num) {
    text = text.substring(0, num) + '...'
  }
  return text
}

/**
 * addUrlInNoMsg:
 *  URLlinkのみでnodeのhtml削除表示で全textが消えてしまった場合、textに'URL'と表示
 * @param {string} text nodeのメッセージ
 * @return {string} URLを追加したmessage
 */
export function addUrlInNoMsg (text) {
  if (text.length === 0) {
    text = 'URL'
  }
  return text
}

/**
 * sortArraybyCreatedAt:
 *  指定のarrayをcreatedAt順でソート
 * @param {array}  arrayTmp 指定配列
 * @return {array} createdAt順でソートされた配列
 */
export function sortArraybyCreatedAt (arrayTmp) {
  let array = arrayTmp
  array.sort(function (a, b) {
    if (a.createdAt < b.createdAt) {
      return 1
    } else {
      return -1
    }
  })
  return array
}

/**
 * sortArraybyUpdatedAt:
 *  指定のarrayをupdatedAt順でソート
 * @param {array}  arrayTmp 指定配列
 * @return {array} updatedAt順でソートされた配列
 */
export function sortArraybyUpdatedAt (arrayTmp) {
  let array = arrayTmp
  array.sort(function (a, b) {
    if (a.updatedAt < b.updatedAt) {
      return 1
    } else {
      return -1
    }
  })
  return array
}

/**
 * sortArraybyNumber:
 *  指定のarrayをNumber順でソート
 * @param {array}  arrayTmp 指定配列
 * @return {array} number順でソートされた配列
 */
export function sortArraybyNumber (arrayTmp) {
  let array = arrayTmp
  array.sort(function (a, b) {
    if (a.number < b.number) {
      return -1
    } else {
      return 1
    }
  })
  return array
}

/**
 * sortArraybyOrder:
 *  指定のarrayをorder順でソート
 * @param {array}  arrayTmp 指定配列
 * @return {array} order順でソートされた配列
 */
export function sortArraybyOrder (arrayTmp) {
  let array = arrayTmp
  array.sort(function (a, b) {
    if (a.order < b.order) {
      return -1
    } else {
      return 1
    }
  })
  return array
}

/**
 * Profile関係
 */

/**
 *  svg2imageData:
 *  svgをpngに変換する関数
 * @param {string} svgElement svgの画像
 * @return {string} imaggeの返却
 */
export async function svg2imageData (svgElement) {
  return new Promise((resolve, reject) => {
    var canvas = document.createElement('canvas')
    canvas.width = 1200
    canvas.height = 630
    var ctx = canvas.getContext('2d')
    var image = new Image()
    image.onload = () => {
      ctx.drawImage(image, 0, 0, 1200, 630)
      resolve(canvas.toDataURL())
    }
    image.onerror = (e) => reject(e)
    var svgData = new XMLSerializer().serializeToString(svgElement)
    image.src = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(unescape(encodeURIComponent(svgData)))
  })
}

/**
 * hasAdminRole:
 *   管理者ユーザかどうか確認する
 *   Analyticsの除外などで使う
 * @param {*} userId
 * @returns
 */
export function hasAdminRole (userId) {
  const adminIds = ['q2Q5xEMtEvSASYQCAD3EXfQpAIT2', 'ofPMMUKXIFfn5FUvwY0LV8DJOIr1', 'AYxQ0fEOWdTc34nQ5kb25Hp1dt82']
  return adminIds.includes(userId)
}

/**
 * getProfileImageUrl:
 *   ランダムに１枚画像URLを取得する
 * @param {*} userId
 * @returns
 */
export function getProfileImageUrl () {
  let imageArray = []

  if (location.hostname === 'qnqtree.com' || location.hostname === '2ndchat.com') {
    imageArray = [
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile?alt=media&token=34b3cd1f-0200-46f3-ac4e-eb8d2cfba19e',
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile0?alt=media&token=61af0361-af46-4c6e-b9ce-5f2aab744ee7',
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile1?alt=media&token=4a33729c-ab75-474f-9921-0b6df2e8e9a1',
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile2?alt=media&token=8a301852-59f2-4b4e-a435-e98899321774',
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile3?alt=media&token=3769f4c7-80d9-4b2e-84a3-3395fdc2521c',
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile4?alt=media&token=472a653e-e737-42e2-b381-55c0c611d38f',
      'https://firebasestorage.googleapis.com/v0/b/secondchat-chat.appspot.com/o/users%2FnoName%2Fprofile5?alt=media&token=1065bb3f-1a82-443d-865f-53e3d8364f0b'
    ]
  } else {
    imageArray = [
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile?alt=media&token=24ddc822-c851-4d32-b5db-f45317b77b36',
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile0?alt=media&token=be89fbdf-b24f-4b68-9ac2-c7a1d57885e4',
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile1?alt=media&token=12e49aee-5048-4063-bce6-8a51ef701596',
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile2?alt=media&token=3edb82de-a24a-489f-9168-28056c0484b1',
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile3?alt=media&token=bf7666fc-0fbb-4fe8-a071-e8243a642b30',
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile4?alt=media&token=3cae3df7-ea1e-40b0-b135-55e61c4bfead',
      'https://firebasestorage.googleapis.com/v0/b/test-qnq.appspot.com/o/users%2FnoName%2Fprofile5?alt=media&token=b1fc437c-0e9b-4064-8cde-9ffa5c54d69a'
    ]
  }
  // 配列内で乱数を発生
  const randomIndex = Math.floor(Math.random() * imageArray.length)
  // 乱数番目のURLを返却
  return imageArray[randomIndex]
}

/**
 * Tree関係
 */

/**
 * getTouchSpeed:
 *  touchの慣性動作の減衰速度を計算する。
 *
 * @param {Number} initSpeedX X方向の初期速度
 * @param {Number} initSpeedY Y方向の初期速度
 * @param {Number} timeCount 慣性ループの回数
 * @return {string} [touchSpeedX, touchSpeedY]
 */
export async function getTouchSpeed (initSpeedX, initSpeedY, timeCount) {
  // 慣性計算の時間幅として1ms wait Timerを入れる
  await new Promise(resolve => setTimeout(resolve, 1))
  // Speedの計算 ダンパー係数を用いた物理減衰 F=ma -> v(t)=v(0)-at
  const alpha = 25.0
  const touchSpeedX = (initSpeedX - (alpha * timeCount) > 1) ? initSpeedX - (alpha * timeCount) : 0
  const touchSpeedY = (initSpeedY - (alpha * timeCount) > 1) ? initSpeedY - (alpha * timeCount) : 0
  return [touchSpeedX, touchSpeedY]
}

/**
 * getMembersNewNode:
 *  各team memberの最新のポストしたnode番号を取得する
 *
 * @param {array} questions nodes配列
 * @param {array} members teamのmember配列
 * @return {array} member配列に最新のnodeと最新のnodeがあるかを追加した配列
 */
export function getMembersNewNode (questions, members) {
  let array = []
  for (const member of members) {
    let data = member
    const memberQuestions = questions.filter(({userId}) => userId === member.userId)
    if (memberQuestions.length === 0) {
      data.newNode = ''
      data.hasNode = false
    } else {
      const maxNumber = Math.max(...memberQuestions.map((question) => question.number))
      data.newNode = maxNumber
      data.hasNode = true
    }
    array.push(data)
  }
  return array
}

/**
 * getQuestionsForTree:
 *  nodes配列からgraph描画に必要なquestion配列と最新のquestion情報を作り返却
 *
 * @param {array} nodes nodes配列
 * @return {array} question配列と最新のquestion
 */
export function getQuestionsForTree (nodes) {
  let questionsForTreeTmp = []
  let latestNode = {}
  Object.keys(nodes).forEach(key => {
    // 削除nodeはskip
    if (nodes[key].marker === 'deleted' && nodes[key].childsNum === 0) { return }
    const graphData = {
      questionId: key,
      number: nodes[key].number,
      question: nodes[key].question,
      parentId: nodes[key].parentId,
      color: nodes[key].marker,
      cloneCardId: nodes[key].cloneCardId ? nodes[key].cloneCardId : null,
      userId: nodes[key].userId,
      mentionedIds: nodes[key].mentionedUsers,
      likesNum: nodes[key].likesNum ? nodes[key].likesNum : 0,
      hasRef: !!nodes[key].reference,
      order: nodes[key].order
    }
    questionsForTreeTmp.push(graphData)
    latestNode.id = key
    latestNode.number = nodes[key].number
    latestNode.userId = nodes[key].userId
  })
  questionsForTreeTmp = sortArraybyOrder(questionsForTreeTmp)
  return [questionsForTreeTmp, latestNode]
}

/**
 * Mention関係
 */

/**
 * removeMention:
 *   Mentionを削除する
 * @param {string} text nodeのメッセージ
 * @param {array} mentionedIds mentionされてるuid配列
 * @param {array} members team memberの配列
 * @return {string} mentionを除外したtext
 */
export function removeMention (text, mentionedIds, members) {
  // mentionが存在しなければそのままmsgを返却
  if (!mentionedIds) { return text }
  // mentionが存在する場合は、処理開始
  for (const uid of mentionedIds) {
    const targetIndex = members.findIndex(({userId}) => userId === uid)
    if (targetIndex !== -1) {
      const targetName = '@' + members[targetIndex].name.replace(/\s+/g, '')
      // mention文字列の削除
      text = text.replace(targetName, '')
    }
  }
  return text
}
/**
 * getMentionableFormat:
 *  mentionを使用するために名前のアット配列を作る
 * @param {array}  members チームメンバー配列
 * @return {array} numberにアット指名を追加した配列
 */
export function getMentionableFormat (members) {
  let array = []
  for (const user of members) {
    const data = {
      value: '@' + user.name.replace(/\s+/g, ''),
      userId: user.userId
    }
    array.push(data)
  }
  return array
}
/**
 * getMentionedUsers:
 *  文章中の氏名からuid検索し取得して返却
 * @param {string} text 入力されたメッセージ
 * @param {array} users mention情報ありのチームメンバー配列
 * @return {array} 指定されたuidsの配列
 */
export function getMentionedUsers (text, users) {
  let array = []
  for (const user of users) {
    if (text.includes(user.value)) {
      array.push(user.userId)
    }
  }
  return array
}
/**
 * addMentionHighlight :
 *  文章中にメンションされた氏名があった場合、ハイライトする
 * @param {string} message 入力されたメッセージ
 * @param {array} users mention情報ありのチームメンバー配列
 * @return {array} 装飾されたmessage
 */
export function addMentionHighlight (message, users) {
  if (!message) { return }
  for (const user of users) {
    message = message.replace(user.value, '<span class="text has-text-weight-bold has-text-link">' + user.value + '</span>')
  }
  return message
}



// WEBPACK FOOTER //
// ./src/api/Utilities.js